import React from 'react';
import { Loading } from 'snacks-design-system';
interface componentProps {
  isActive?: boolean;
  background?: '' | 'overlay' | 'screen';
  size?: 'xs' | 's' | 'm' | 'l' | 'xl';
  mode?: 'primary' | 'secondary' | 'tertiary' | 'inverse' | 'secondary-inv';
  modInline?: boolean;
  aria?: { label?: string };
  dataSctrack?: string;
  qaSelector?: string;
}

const PIELoading = (props: componentProps) => {
  return <Loading {...props} />;
};

export default PIELoading;
